import * as React from 'react';

interface IDefinitionListProps {
	defs: Array<{ title: string; text: string; link?: string, subText?: string }>;
}

const DefinitionList: React.FC<IDefinitionListProps> = ({ defs }) => {
	return <dl className="definition-list">
		{(defs || []).map((def, i) =>
			<React.Fragment key={i} >
				<dt key={`dt_${i}`} className="definition-list__title">{def.title}</dt>
				{
					def.subText && <dd className="definition-list__definition">{def.subText}</dd>
				}
				{
					def.link ? <a key={`a_${i}`} target="_blank" href={def.link}>{def.text}</a> :
						<dd key={`dd_${i}`} className="definition-list__definition">{def.text}</dd>
				}
			</React.Fragment>)}
	</dl>;
};

export default DefinitionList;
